module.exports = __webpack_public_path__ + "assets/red-and-blue-pc-en.cf58fd43.svg";